// This file was generated by svgr, do not edit it.
import * as React from 'react'
import { clsx } from 'clsx'
import styles from '../Icon.module.css'
import {
  computeStrokeWidth,
  computeSize,
  getIconColorClassName,
} from '../helpers'
import type { IconProps, IconComponentRef } from '../helpers'
const CommentRoundFilledIcon = React.forwardRef(
  (
    { size, stroke, className, color, ...props }: IconProps,
    ref: IconComponentRef,
  ) => {
    const iconName = 'comment-round-filled'
    const computedSize = computeSize(size)
    const computedStrokeWidth = computeStrokeWidth(computedSize, stroke)
    return (
      <svg
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(className, styles.base, getIconColorClassName(color))}
        data-icon={iconName}
        aria-hidden="true"
        strokeWidth={computedStrokeWidth}
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <path
          d="M6.58341 16.6667C8.1739 17.4826 10.0035 17.7036 11.7425 17.2898C13.4815 16.8761 15.0155 15.8549 16.0682 14.4102C17.1209 12.9655 17.6229 11.1923 17.4839 9.41015C17.3449 7.62803 16.5739 5.95416 15.3099 4.69018C14.0459 3.4262 12.3721 2.65523 10.5899 2.5162C8.80782 2.37717 7.03464 2.87922 5.58993 3.93189C4.14522 4.98456 3.12399 6.51861 2.71027 8.25761C2.29654 9.99661 2.51753 11.8262 3.33341 13.4167L1.66675 18.3334L6.58341 16.6667Z"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)
CommentRoundFilledIcon.displayName = 'CommentRoundFilledIcon'
export { CommentRoundFilledIcon }
